import { OnDestroy, Pipe, PipeTransform } from "@angular/core";
import { Subject } from "rxjs";

@Pipe({
  name: "humanizeCamelCase",
})
export class HumanizeCamelCasePipe implements PipeTransform,OnDestroy {
  private destroy$ = new Subject<void>();
  transform(value: unknown, ...args: unknown[]): unknown {
    return this.deCapitalizedWords(value);
  }

  deCapitalizedWords(name) {
    const words = name && name.match(/[A-Za-z][a-z]*/g) || [];
    return words.map(this.capitalize).join(" ");
  }

  capitalize(word) {
    return word.charAt(0).toUpperCase() + word.substring(1);
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.unsubscribe();
  }
}
